import * as React from 'react'
import 'katex/dist/katex.min.css';
import styled from "styled-components";
import Latex from 'react-latex-next';

class Equation extends React.Component {
  render() {
    let equation = this.props.equation;
    let math_type = this.props.math_type ? this.props.math_type : 0;
    if (!equation) return null;
    equation = equation.toString();
    return (
      <div className="equation" style={{ color: this.props.is_answer ? 'white' : 'black' }}>

        {math_type == 0 &&
          <span dangerouslySetInnerHTML={{ __html: equation }} />
        }
        {math_type == 1 &&
          <Latex >{equation}</Latex>
        }
        <style jsx='true' scoped>{`
          .equation{
            font-size: 13px;
            font-weight: 400;
            line-height: 20.83px;
            margin-bottom:10px;
            word-break: break-word;
            font-weight: ${'bold' in this.props ? this.props.bold : '500'};
          }
        `}
        </style>
      </div>
    )
  }
}
export default Equation;